// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AddEbook.module.css */
.AddEbook_container__6hXl6 {
    background-color: #121212;
    color: #ffffff;
    padding: 2rem;
    min-height: 100vh;
  }
  
  .AddEbook_header__-mCnA {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 2rem;
  }
  
  .AddEbook_headerIcon__QhfJX {
    color: #ff4444;
    width: 32px;
    height: 32px;
  }
  
  .AddEbook_header__-mCnA h1 {
    color: #ffffff;
    font-size: 2rem;
  }
  
  .AddEbook_form__YBfu4 {
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .AddEbook_formGroup__Ec0rU {
    margin-bottom: 1.5rem;
  }
  
  .AddEbook_formGroup__Ec0rU label {
    display: block;
    margin-bottom: 0.5rem;
    color: #ffffff;
  }
  
  .AddEbook_formGroup__Ec0rU input[type="text"],
  .AddEbook_formGroup__Ec0rU textarea {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #333;
    border-radius: 4px;
    background-color: #1e1e1e;
    color: #ffffff;
    font-size: 1rem;
  }
  
  .AddEbook_formGroup__Ec0rU input[type="text"]:focus,
  .AddEbook_formGroup__Ec0rU textarea:focus {
    outline: none;
    border-color: #ff444400;
  }
  
  .AddEbook_imageUploadSection__OuzbN {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;
    margin-bottom: 2rem;
  }
  
  @media (min-width: 768px) {
    .AddEbook_imageUploadSection__OuzbN {
      grid-template-columns: 1fr 1fr;
    }
  }
  
  .AddEbook_imageUpload__G7TKP {
    background-color: #1e1e1e;
    border-radius: 8px;
    padding: 1rem;
  }
  
  .AddEbook_uploadArea__GJgaF {
    min-height: 200px;
    border: 2px dashed #333;
    border-radius: 4px;
    position: relative;
  }
  
  .AddEbook_uploadPlaceholder__prfa\\+ {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 200px;
    cursor: pointer;
    color: #888;
  }
  
  .AddEbook_uploadPlaceholder__prfa\\+:hover {
    color: #ff4444;
  }
  
  .AddEbook_uploadPlaceholder__prfa\\+ svg {
    width: 48px;
    height: 48px;
    margin-bottom: 1rem;
  }
  
  .AddEbook_fileInput__0LjIz {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
  
  .AddEbook_imagePreview__Uxc-y {
    position: relative;
    height: 200px;
  }
  
  .AddEbook_imagePreview__Uxc-y img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
  }
  
  .AddEbook_removeButton__8pUFR {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    background-color: rgba(0, 0, 0, 0.5);
    border: none;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #ffffff;
  }
  
  .AddEbook_removeButton__8pUFR:hover {
    background-color: #ff4444;
  }
  
  .AddEbook_checkboxLabel__gP\\+4Z {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
  }
  
  .AddEbook_checkboxLabel__gP\\+4Z input[type="checkbox"] {
    width: 18px;
    height: 18px;
    accent-color: #ff4444;
  }
  
  .AddEbook_submitButton__T5QuA {
    background-color: #ff4444;
    color: #ffffff;
    border: none;
    border-radius: 4px;
    padding: 1rem 2rem;
    font-size: 1rem;
    cursor: pointer;
    width: 100%;
    margin-top: 2rem;
    transition: background-color 0.2s;
  }
  
  .AddEbook_submitButton__T5QuA:hover {
    background-color: #ff2222;
  }
  
  /* Jodit Editor custom styles */
  .jodit-container {
    border-color: #333 !important;
  }
  
  .jodit-workplace {
    background-color: #1e1e1e !important;
  }
  
  .jodit-toolbar__box {
    background-color: #252525 !important;
  }
  
  .jodit-toolbar-button {
    color: #ffffff !important;
  }
  
  .jodit-toolbar-button:hover {
    background-color: #333 !important;
  }
  
  .jodit-status-bar {
    background-color: #252525 !important;
    border-color: #333 !important;
  }


  .AddEbook_select__qGr3v {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #333;
    border-radius: 4px;
    background-color: #1e1e1e;
    font-size: 1rem;
    color: white;
  }
  
  .AddEbook_select__qGr3v:focus {
    outline: none;
    border-color: red;
    box-shadow: 0 0 0 2px red(0, 123, 255, 0.25);
  }
   /* Searchable Select Wrapper */
.AddEbook_searchableSelect__8cucp {
  position: relative;
  display: flex;
  align-items: center;
  background-color: #1e1e1e;
  border: 1px solid #333333;
  border-radius: 6px;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.AddEbook_searchableSelect__8cucp:hover {
  border-color: #ff3333;
}

.AddEbook_searchableSelect__8cucp input {
  flex-grow: 1;
  background: transparent;
  border: none;
  color: #f0f0f0;
  font-size: 1rem;
  outline: none;
  width: 100%;
}

.AddEbook_searchableSelect__8cucp .AddEbook_dropdownArrow__2Pjm9 {
  margin-left: 8px;
  font-size: 14px;
  color: #ff6666;
  transition: transform 0.2s ease;
}

.AddEbook_searchableSelect__8cucp.AddEbook_open__FFg0B .AddEbook_dropdownArrow__2Pjm9 {
  transform: rotate(180deg);
}

/* Dropdown List */
.AddEbook_dropdownList__047dQ {
 background-color: #1e1e1e;
  border: 1px solid #333333;
  border-radius: 6px;
  margin-top: 5px;
  list-style: none;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  animation: AddEbook_fadeIn__2RZfO 0.2s ease-in-out;
}

.AddEbook_dropdownItem__Y00ej {
  padding: 10px 14px;
  font-size: 1rem;
  color: #f0f0f0;
  transition: background 0.2s ease, color 0.2s ease;
  cursor: pointer;
}

.AddEbook_dropdownItem__Y00ej:hover {
  background-color: #ff3333;
  color: #ffffff;
}

.AddEbook_dropdownItem__Y00ej:empty {
  color: #888888;
  text-align: center;
}

.AddEbook_dropdownList__047dQ::-webkit-scrollbar {
  width: 6px;
}

.AddEbook_dropdownList__047dQ::-webkit-scrollbar-thumb {
  background: #ff3333;
  border-radius: 4px;
}

.AddEbook_dropdownList__047dQ::-webkit-scrollbar-track {
  background: #222222;
}

@keyframes AddEbook_fadeIn__2RZfO {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/admin/pages/Ebook/AddEbook.module.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,cAAc;EAChB;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;EACjB;;EAEA;;IAEE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE;MACE,8BAA8B;IAChC;EACF;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,oCAAoC;IACpC,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,+BAA+B;EAC/B;IACE,6BAA6B;EAC/B;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,oCAAoC;IACpC,6BAA6B;EAC/B;;;EAGA;IACE,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,4CAA4C;EAC9C;GACC,8BAA8B;AACjC;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;CACC,yBAAyB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,wCAAwC;EACxC,kDAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iDAAiD;EACjD,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":["/* AddEbook.module.css */\n.container {\n    background-color: #121212;\n    color: #ffffff;\n    padding: 2rem;\n    min-height: 100vh;\n  }\n  \n  .header {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    margin-bottom: 2rem;\n  }\n  \n  .headerIcon {\n    color: #ff4444;\n    width: 32px;\n    height: 32px;\n  }\n  \n  .header h1 {\n    color: #ffffff;\n    font-size: 2rem;\n  }\n  \n  .form {\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n  \n  .formGroup {\n    margin-bottom: 1.5rem;\n  }\n  \n  .formGroup label {\n    display: block;\n    margin-bottom: 0.5rem;\n    color: #ffffff;\n  }\n  \n  .formGroup input[type=\"text\"],\n  .formGroup textarea {\n    width: 100%;\n    padding: 0.75rem;\n    border: 1px solid #333;\n    border-radius: 4px;\n    background-color: #1e1e1e;\n    color: #ffffff;\n    font-size: 1rem;\n  }\n  \n  .formGroup input[type=\"text\"]:focus,\n  .formGroup textarea:focus {\n    outline: none;\n    border-color: #ff444400;\n  }\n  \n  .imageUploadSection {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 2rem;\n    margin-bottom: 2rem;\n  }\n  \n  @media (min-width: 768px) {\n    .imageUploadSection {\n      grid-template-columns: 1fr 1fr;\n    }\n  }\n  \n  .imageUpload {\n    background-color: #1e1e1e;\n    border-radius: 8px;\n    padding: 1rem;\n  }\n  \n  .uploadArea {\n    min-height: 200px;\n    border: 2px dashed #333;\n    border-radius: 4px;\n    position: relative;\n  }\n  \n  .uploadPlaceholder {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 200px;\n    cursor: pointer;\n    color: #888;\n  }\n  \n  .uploadPlaceholder:hover {\n    color: #ff4444;\n  }\n  \n  .uploadPlaceholder svg {\n    width: 48px;\n    height: 48px;\n    margin-bottom: 1rem;\n  }\n  \n  .fileInput {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    cursor: pointer;\n  }\n  \n  .imagePreview {\n    position: relative;\n    height: 200px;\n  }\n  \n  .imagePreview img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 4px;\n  }\n  \n  .removeButton {\n    position: absolute;\n    top: 0.5rem;\n    right: 0.5rem;\n    background-color: rgba(0, 0, 0, 0.5);\n    border: none;\n    border-radius: 50%;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    color: #ffffff;\n  }\n  \n  .removeButton:hover {\n    background-color: #ff4444;\n  }\n  \n  .checkboxLabel {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    cursor: pointer;\n  }\n  \n  .checkboxLabel input[type=\"checkbox\"] {\n    width: 18px;\n    height: 18px;\n    accent-color: #ff4444;\n  }\n  \n  .submitButton {\n    background-color: #ff4444;\n    color: #ffffff;\n    border: none;\n    border-radius: 4px;\n    padding: 1rem 2rem;\n    font-size: 1rem;\n    cursor: pointer;\n    width: 100%;\n    margin-top: 2rem;\n    transition: background-color 0.2s;\n  }\n  \n  .submitButton:hover {\n    background-color: #ff2222;\n  }\n  \n  /* Jodit Editor custom styles */\n  :global(.jodit-container) {\n    border-color: #333 !important;\n  }\n  \n  :global(.jodit-workplace) {\n    background-color: #1e1e1e !important;\n  }\n  \n  :global(.jodit-toolbar__box) {\n    background-color: #252525 !important;\n  }\n  \n  :global(.jodit-toolbar-button) {\n    color: #ffffff !important;\n  }\n  \n  :global(.jodit-toolbar-button:hover) {\n    background-color: #333 !important;\n  }\n  \n  :global(.jodit-status-bar) {\n    background-color: #252525 !important;\n    border-color: #333 !important;\n  }\n\n\n  .select {\n    width: 100%;\n    padding: 8px 12px;\n    border: 1px solid #333;\n    border-radius: 4px;\n    background-color: #1e1e1e;\n    font-size: 1rem;\n    color: white;\n  }\n  \n  .select:focus {\n    outline: none;\n    border-color: red;\n    box-shadow: 0 0 0 2px red(0, 123, 255, 0.25);\n  }\n   /* Searchable Select Wrapper */\n.searchableSelect {\n  position: relative;\n  display: flex;\n  align-items: center;\n  background-color: #1e1e1e;\n  border: 1px solid #333333;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: border-color 0.2s ease;\n}\n\n.searchableSelect:hover {\n  border-color: #ff3333;\n}\n\n.searchableSelect input {\n  flex-grow: 1;\n  background: transparent;\n  border: none;\n  color: #f0f0f0;\n  font-size: 1rem;\n  outline: none;\n  width: 100%;\n}\n\n.searchableSelect .dropdownArrow {\n  margin-left: 8px;\n  font-size: 14px;\n  color: #ff6666;\n  transition: transform 0.2s ease;\n}\n\n.searchableSelect.open .dropdownArrow {\n  transform: rotate(180deg);\n}\n\n/* Dropdown List */\n.dropdownList {\n background-color: #1e1e1e;\n  border: 1px solid #333333;\n  border-radius: 6px;\n  margin-top: 5px;\n  list-style: none;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 10;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  animation: fadeIn 0.2s ease-in-out;\n}\n\n.dropdownItem {\n  padding: 10px 14px;\n  font-size: 1rem;\n  color: #f0f0f0;\n  transition: background 0.2s ease, color 0.2s ease;\n  cursor: pointer;\n}\n\n.dropdownItem:hover {\n  background-color: #ff3333;\n  color: #ffffff;\n}\n\n.dropdownItem:empty {\n  color: #888888;\n  text-align: center;\n}\n\n.dropdownList::-webkit-scrollbar {\n  width: 6px;\n}\n\n.dropdownList::-webkit-scrollbar-thumb {\n  background: #ff3333;\n  border-radius: 4px;\n}\n\n.dropdownList::-webkit-scrollbar-track {\n  background: #222222;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-5px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AddEbook_container__6hXl6`,
	"header": `AddEbook_header__-mCnA`,
	"headerIcon": `AddEbook_headerIcon__QhfJX`,
	"form": `AddEbook_form__YBfu4`,
	"formGroup": `AddEbook_formGroup__Ec0rU`,
	"imageUploadSection": `AddEbook_imageUploadSection__OuzbN`,
	"imageUpload": `AddEbook_imageUpload__G7TKP`,
	"uploadArea": `AddEbook_uploadArea__GJgaF`,
	"uploadPlaceholder": `AddEbook_uploadPlaceholder__prfa+`,
	"fileInput": `AddEbook_fileInput__0LjIz`,
	"imagePreview": `AddEbook_imagePreview__Uxc-y`,
	"removeButton": `AddEbook_removeButton__8pUFR`,
	"checkboxLabel": `AddEbook_checkboxLabel__gP+4Z`,
	"submitButton": `AddEbook_submitButton__T5QuA`,
	"select": `AddEbook_select__qGr3v`,
	"searchableSelect": `AddEbook_searchableSelect__8cucp`,
	"dropdownArrow": `AddEbook_dropdownArrow__2Pjm9`,
	"open": `AddEbook_open__FFg0B`,
	"dropdownList": `AddEbook_dropdownList__047dQ`,
	"fadeIn": `AddEbook_fadeIn__2RZfO`,
	"dropdownItem": `AddEbook_dropdownItem__Y00ej`
};
export default ___CSS_LOADER_EXPORT___;
